var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "hsl(205, 70%, 31%)",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 21,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.64,
    cy: 5.64,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.36,
    cy: 18.36,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.64,
    cy: 18.36,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.36,
    cy: 5.64,
    r: 2
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    dur: "1.5s",
    values: "0 12 12;360 12 12",
    repeatCount: "indefinite"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.b92bb8e51ed847871b87575ae2eb4349.svg";
export { ForwardRef as ReactComponent };